export const setResourcesPath = (id) => {
  switch (id) {
    case 1:
      return 'experts';
    case 2:
      return 'community';
    case 3:
      return 'guidebooks';
    case 4:
      return 'faqs';
    default:
      return 'experts';
  }
};

export const setTitleFromPath = (name) => name.substr(1).charAt(0).toUpperCase() + name.slice(2);

export const calculationLoanEMI = (ir, np, pv, fv = 0) => {
  /*
 ir - interest rate per month
 np - number of periods (months)
 pv - present value
 fv - future value (residual value)
 */
  let pmt = (ir * (pv * Math.pow(ir + 1, np) + fv)) / ((ir + 1) * (Math.pow(ir + 1, np) - 1));
  return Math.ceil(pmt);
};

export const calculationTotalInterest = (loanEMI, loanTenure) => loanEMI * loanTenure * 12;

export const getCalculation = (homeLoanAmount = 1, interestRate = 1, loanTenure = 1) => {
  const periodInmonths = loanTenure * 12;
  const rateInMonth = interestRate / 12 / 100;

  let array = [];
  let totalInterest = 0;

  for (let i = 1; i <= loanTenure * 12; i++) {
    let data = {};

    if (array.length) {
      data = {
        month: i,
        amount: array[i - 2].remainingPrincipalAmound,
        instalment: calculationLoanEMI(rateInMonth, periodInmonths, homeLoanAmount),
        interest: Math.round((array[i - 2].remainingPrincipalAmound * interestRate) / 1200),
        principalRepaid: Math.ceil(
          calculationLoanEMI(rateInMonth, periodInmonths, homeLoanAmount) -
            (array[i - 2].remainingPrincipalAmound * interestRate) / 1200
        ),
        remainingPrincipalAmound: Math.round(
          array[i - 2].remainingPrincipalAmound -
            (calculationLoanEMI(rateInMonth, periodInmonths, homeLoanAmount) -
              (array[i - 2].remainingPrincipalAmound * interestRate) / 1200)
        )
      };
      totalInterest =
        totalInterest + Math.round((array[i - 2].remainingPrincipalAmound * interestRate) / 1200);
    } else {
      data = {
        month: i,
        amount: +homeLoanAmount,
        instalment: calculationLoanEMI(rateInMonth, periodInmonths, homeLoanAmount),
        interest: Math.round((homeLoanAmount * interestRate) / 1200),
        principalRepaid:
          calculationLoanEMI(rateInMonth, periodInmonths, homeLoanAmount) -
          (homeLoanAmount * interestRate) / 1200,
        remainingPrincipalAmound: Math.round(
          homeLoanAmount -
            (calculationLoanEMI(rateInMonth, periodInmonths, homeLoanAmount) -
              (homeLoanAmount * interestRate) / 1200)
        )
      };
      totalInterest = totalInterest + (homeLoanAmount * interestRate) / 1200;
    }

    array.push(data);
  }

  console.log('array', array);
  return Math.ceil(totalInterest);
};
